import gql from 'graphql-tag';

export const ARTICLE_SETTINGS_QUERY = gql`
  query ArticleSettingsQuery($id: ID!) {
    article(id: $id) {
      id
      url
      fullUrl
      title
      deprecated
      starred
      manualExpirationTime
      setByRuleExpirationTime
      defaultExpirationTime
      budgetCapDollars
      goalCpcDollars
      specialAdCategories
      applicablePolicies
      isPolitical
      addtionalParameters
      targetingSelection {
        ageMin
        ageMax
        relationshipStatuses
      }
      discountSettings {
        id
        enabled
        discountType
        discountValue
      }
      facebookPageId
      facebookAdsCount
      creatives {
        id
      }
      campaign {
        id
        cpaRiskFactor
        maxCpa
        useSavedAudience
        discountSettings {
          id
          enabled
          discountType
          discountValue
        }
        publisher {
          name
          publisherFacebookAccounts {
            priority
            facebookAccount {
              accountId
              businessId
            }
          }
          facebookAccounts {
            accountId
            timezone
          }
        }
        pageLockedArticlesEnabled
        campaignFacebookPages {
          id
          facebookPageId
          facebookPageDisplayName
        }
        facebookPageAssignments {
          facebookPageId
          trackingParamKey
          trackingParamValue
        }
      }
    }
  }
`;
